import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "contact",
  class: "py-2 light-section"
}
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = { class: "elbow-layout" }
const _hoisted_4 = { class: "label start" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text-box" }
const _hoisted_8 = { class: "button-wrapper" }
const _hoisted_9 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.startLabel), 1),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactItems, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['item', _ctx.getItemPosition(index)])
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "left-elbow elbow" }, null, -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item), 1)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "right-elbow elbow" }, null, -1))
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              class: "btn btn-primary btn-lg mt-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/contact')))
            }, _cache[3] || (_cache[3] = [
              _createTextVNode(" Kontaktieren Sie uns "),
              _createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
            ]))
          ])
        ])
      ])
    ])
  ]))
}